import React from 'react';
import { ExpenseItem } from './ExpenseItem';

interface ExpenseItemData {
    id: number;
    description: string;
    amount: number;
    paidBy: string;
    splitCount: number;
}

interface ExpenseListProps {
    expenses: ExpenseItemData[];
    totalAmount: number;
    onRemove: (id: number) => void;
}

export const ExpenseList: React.FC<ExpenseListProps> = ({ expenses, totalAmount, onRemove }) => {
    if (expenses.length === 0) return null;

    return (
        <div className="expense-list">
            <div className="list-header">
                <h3 className="list-title">입력된 지출</h3>
                <span className="total-amount">총 {totalAmount.toLocaleString('ko-KR')}원</span>
            </div>

            <div className="expense-items">
                {expenses.map(expense => (
                    <ExpenseItem
                        key={expense.id}
                        expense={expense}
                        onRemove={onRemove}
                    />
                ))}
            </div>
        </div>
    );
};
